import { renderTemplate } from '../../Utils/templateUtils';

export default class BlogApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(BlogApi.getAllBlogPostsPath);
        this.DashAPI.ApiPathMgr.add(BlogApi.getBlogPostByIdPath);
        this.DashAPI.ApiPathMgr.add(BlogApi.getBlogPostByUrlPath);
        this.DashAPI.ApiPathMgr.add(BlogApi.getFeaturedBlogPostsPath);
    }

    getAllBlogPosts() {
        return this.DashAPI.CORE.get(BlogApi.getAllBlogPostsPath);
    }

    getBlogPostById(blogId) {
        var urlPath = renderTemplate(BlogApi.getBlogPostByIdPath, { blogId });
        return this.DashAPI.CORE.get(urlPath);
    }

    getBlogPostByUrlPath(params) {
        return this.DashAPI.CORE.get(BlogApi.getBlogPostByUrlPath, params);
    }

    getFeaturedBlogPosts() {
        return this.DashAPI.CORE.get(BlogApi.getFeaturedBlogPostsPath);
    }

    getSitemap(){
        return this.DashAPI.CORE.getXML(BlogApi.SitemapPath);
    }
}

BlogApi.SitemapPath = '/api/blog/sitemap';
BlogApi.getAllBlogPostsPath = '/api/blog/trends';
BlogApi.getBlogPostByIdPath = '/api/blog/trends/{blogId}';
BlogApi.getBlogPostByUrlPath = '/api/blog/trends/url';
BlogApi.getFeaturedBlogPostsPath = '/api/blog/trends/featured';



// WEBPACK FOOTER //
// ./src/PublicApi/blog/BlogApi.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/blog/BlogApi.js